import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'next-i18next'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { TEXT_FIELD_MULTILINE_SX } from 'src/constants/theme'
import useErrorSnackbar from 'src/hooks/useErrorSnackbar'
import { IMutation, IMutationReportUserArgs, IUser } from '../types/graphql'
import BaseButton from './Buttons/BaseButton'
import ModalDrawer from './ModalDrawer'

const REPORT_USER = gql`
  mutation ReportUser($input: ReportUserInput!) {
    reportUser(input: $input)
  }
`

type IProps = {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  user: IUser
  chatId?: string
}

export default function ReportUserModal({
  user,
  chatId,
  isOpen,
  setIsOpen
}: IProps) {
  const { id } = user
  const { t: tCommon } = useTranslation('common')

  const [message, setMessage] = useState<string>('')

  const { enqueueSnackbar } = useSnackbar()
  const enqueueError = useErrorSnackbar()

  const [reportUser, { loading }] = useMutation<
    Pick<IMutation, 'reportUser'>,
    IMutationReportUserArgs
  >(REPORT_USER, {
    onCompleted: () => {
      enqueueSnackbar('Usuario reportado.', { variant: 'warning' })
      setMessage('')
      setIsOpen(false)
    },
    onError: (error) => {
      enqueueError(error, { logMessage: 'Error reporting user' })
    }
  })

  const handleReportUser = () => {
    reportUser({
      variables: { input: { userId: id, reason: message, chatId } }
    })
  }

  return (
    <ModalDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={tCommon('REPORT_USER_MODAL.TITLE')}
    >
      <div className="flex w-full flex-col items-center justify-center gap-2">
        <div className="flex w-full flex-col gap-2 text-start">
          <h3 className="text-[18px] leading-normal font-semibold text-ink-700">
            ¿Por qué estas reportando este usuario?
          </h3>

          <p className="text-base leading-normal font-medium text-ink-200">
            Esto no sera compartido con el usuario.
          </p>
        </div>

        <TextField
          multiline
          fullWidth
          id="phone"
          label="Mensaje"
          name="message"
          autoComplete="message"
          rows={6}
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          sx={TEXT_FIELD_MULTILINE_SX}
        />

        <BaseButton
          onClick={handleReportUser}
          loading={loading}
          variant="contained"
          fullWidth
          rounded
        >
          Reportarlo
        </BaseButton>
      </div>
    </ModalDrawer>
  )
}
